export default "/img/ST.15766d26f9899e37ef2b3daa7e3bae84.png";